//========================================================================================================
// Use the css variables to edit exposed styles for this component
// Font styles can be inherited from the parent element
//========================================================================================================

(() => {
    const { defineCustomElement, ref, watch, onMounted } = Vue;

    function loadAnimeJS() {
        return new Promise((resolve, reject) => {
            if (window.anime) {
                resolve(window.anime);
                return;
            }

            const script = document.createElement("script");
            script.src = "https://cdnjs.cloudflare.com/ajax/libs/animejs/2.2.0/anime.min.js";
            script.onload = () => resolve(window.anime);
            script.onerror = reject;
            document.head.appendChild(script);
        });
    }

    const NumberCounter = defineCustomElement({
        props: ["number"],
        template: `
             <span ref="counterElement">
                {{ displayNumber }}
            </span>
        `,
        setup(props) {
            const displayNumber = ref(0);
            const counterElement = ref(null);
            const inViewPort = ref(false);
            let observer = null;

            onMounted(async () => {
                await loadAnimeJS();

                if (counterElement.value) {
                    observer = new IntersectionObserver(handleIntersection, {
                        threshold: 1
                    });
                    observer.observe(counterElement.value);
                }
            });

            watch(() => props.number, (newValue, oldValue) => {
                if (inViewPort.value) {
                    startCounterAnimation(oldValue, newValue);
                }
            });

            function handleIntersection(entries) {
                if (entries[0].isIntersecting) {
                    inViewPort.value = true;
                    startCounterAnimation(0, props.number);
                    observer.disconnect();
                }
            }

            function startCounterAnimation(oldValue = 0, newValue = 0) {
                const obj = { n: oldValue };
                window.anime({
                    targets: obj,
                    n: newValue,
                    round: 1,
                    duration: 1000,
                    easing: 'linear',
                    update: () => {
                        displayNumber.value = obj.n;
                    }
                });
            }

            return { displayNumber, counterElement };
        },
    });

    customElements.define("vue-animated-counter", NumberCounter);
})();
